module.exports = __webpack_public_path__ + "img/5.d701f350.jpg";